import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CollectionForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import StaticTable from '../../../../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../../../../moreCore/Tools/EntityStore';
import { AdditionalFormSaveData, BookingCollectorLoadData, TravelBookingLoadData } from "../../../TravelBookingListTypes";
import lang from 'dojo/_base/lang';
import _TabEnabledMixin from '../../../../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import ExpandableSection from '../../../../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../../../../moreCore/UI/Container/ExpandableSectionTypes";

class CollectionForm extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    private entity: TravelBookingLoadData;


    private store: MdsLax<InstanceType<typeof EntityStore<BookingCollectorLoadData>>>;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private expandableSectionRelatedBookings: MdsLax<InstanceType<typeof ExpandableSection>>;
    private tableContainer: HTMLDivElement;

    private tableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["classname", "desccription", "dateStart", "dateEnd"],
        "attributes": ["ClassPrintname", "description", "date_start", "date_end"],
        "headings": [(this as any).translate("TravelBookingList_Headings_Type"), (this as any).translate("TravelBookingList_Headings_Description"), (this as any).translate("TravelBookingList_Headings_DateStart"), (this as any).translate("TravelBookingList_Headings_DateEnd")],
        bgColors: [null, null, null, null],
    }

    isStoreEmpty(): boolean {
        return this.store.getCurrentCompleteList().length <= 0;
    }

    onInputChange(e): void {
        this.emit("change");
    }

    getData(): AdditionalFormSaveData {
        var formData: any = {};
        return formData;
    }

    prepareData(entity?): void {
        if (entity) {
            this.setEntity(entity);
        }
        this.store = this.store = new EntityStore();
        this.setupForm();
    }

    private setupForm(): void {
        if (this.entity) {
            this.store.setup(this.entity.EL_vt_travel_travel_booking_collector);
        }
        this.table.setupFromStore(this.store);
    }

    private setEntity(entity: TravelBookingLoadData): void {
        this.entity = entity;
    }


    private setupTable(): void {
        this.table = new StaticTable();

        this.table.addLineConfig(this.tableLayout);
        this.table.setCyAttribute("TravelBookingCollectionTable");
        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);
    }

    private _onTableRowClick(row: StaticTable.StaticTableRow<BookingCollectorLoadData>) {
        var entity = row.rowGroup.entity;
        this.emit("newBookingForm", entity);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.setupTable();
        this.expandableSectionRelatedBookings.setMarking(ExpandableSectionMarkings.hasContent);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.getTabContainer()) {
            this.table.setRowClick(lang.hitch(this, this._onTableRowClick));
        }
    }

}

export default mdsWidget(CollectionForm);